export default __webpack_public_path__ + "static/media/resendInvite.c0471910.svg";